import { render } from "./AsPreloader.vue?vue&type=template&id=466f25c0&scoped=true&ts=true"
import script from "./AsPreloader.vue?vue&type=script&lang=ts"
export * from "./AsPreloader.vue?vue&type=script&lang=ts"

import "./AsPreloader.vue?vue&type=style&index=0&id=466f25c0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466f25c0"]])

export default __exports__